import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tBedModel } from '../models/tBedModel';
import { tItemModel, tItemModelwithCateInfo } from '../models/tItemModel';
import { BehaviorSubject } from 'rxjs';
import { preDefineCate } from '../models/tItemCateModel';



@Injectable({
    providedIn: 'root'
})

export class tItemService {

    // Share Data with package New/Edit
    private selected_pack_itemID_Source = new BehaviorSubject('');
    current_selected_pack_itemID = this.selected_pack_itemID_Source.asObservable();

    private selected_pack_itemName_Source = new BehaviorSubject('');
    current_selected_pack_itemName = this.selected_pack_itemName_Source.asObservable();

    private selected_pack_itemUnit_Source = new BehaviorSubject('');
    current_selected_pack_itemUnit = this.selected_pack_itemUnit_Source.asObservable();

    private selected_pack_standardPrice_Source = new BehaviorSubject(0);
    current_selected_pack_standardPrice = this.selected_pack_standardPrice_Source.asObservable();


    // Share Data with Price Book New/Edit (By Model)
    private selected_pricebook_itemModel_Source = new BehaviorSubject<tItemModel>(null);
    current_selected_pricebook_itemModel = this.selected_pricebook_itemModel_Source.asObservable();


    // Share Data with package New/Edit
    shareSelected(selecteditemID: string, selecteditemName: string, selecteditemUnit: string, selectedStandardPrice: number) {
        this.selected_pack_itemID_Source.next(selecteditemID);
        this.selected_pack_itemName_Source.next(selecteditemName);
        this.selected_pack_itemUnit_Source.next(selecteditemUnit);

        this.selected_pack_standardPrice_Source.next(selectedStandardPrice);
    }


    // Share Data with Price Book New/Edit (By Model)
    shareSelectedPriceBook(model: tItemModel) {
        this.selected_pricebook_itemModel_Source.next(model);
    }



    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tItemModels';

    getAllData() {
        return this.http.get<tItemModel[]>(this.baseurl + this.pathName);
    }

    getAllDataWithItemCateInfo(shopID :number) {
        return this.http.get<tItemModelwithCateInfo[]>(this.baseurl + this.pathName + '/WithItemCateInfo/'+shopID);
    }

    getAllDataWithItemCateInfo_isServiceOnly(shopID: number) {
        return this.http.get<tItemModelwithCateInfo[]>(this.baseurl + this.pathName + '/WithItemCateInfo/'+shopID + '/Y');
    }


    getAllDataWithItemCateInfo_isItemOnly(shopID: number) {
        return this.http.get<tItemModelwithCateInfo[]>(this.baseurl + this.pathName + '/WithItemCateInfo/'+shopID + '/N');
    }

    getAllDataWithItemCateInfo_isStockItemOnly(shopID: number) {
        return this.http.get<tItemModelwithCateInfo[]>(this.baseurl + this.pathName + '/WithItemCateInfoIsStock/'+shopID + '/Y');
    }


    getAllDataWithItemCateInfo_ServiceAndItem(shopID: number) {
        return this.http.get<tItemModelwithCateInfo[]>(this.baseurl + this.pathName + '/WithItemCateInfo_TwoCondition/'
        + shopID + '/N' + '/Y');
    }

    getAllDataWithItemCateInfo_isServiceOnly_nonDiagonsis(shopID: number, diagonsisItemCateID: string) {

        if (diagonsisItemCateID === '') {
            diagonsisItemCateID = preDefineCate.diagonsis;
        }

        return this.http.get<tItemModelwithCateInfo[]>(this.baseurl + this.pathName 
            + '/WithItemCateInfoNonDiagonsis/'+shopID + '/' + diagonsisItemCateID);
    }

    getDataById(shopID: string, itemID: string) {
        return this.http.get<tItemModel>(this.baseurl + this.pathName + '/' + shopID + '/' + itemID);
    }

    getItemListByItemCateID(shopID: string, itemCateID: string) {
        return this.http.get<tItemModel[]>(this.baseurl + this.pathName + '/GetItemByItemCate/' + shopID + '/' + itemCateID);

    }

    addData(data: tItemModel) {
        return this.http.post(this.baseurl + this.pathName + '/Formatted', data);
    }

    deleteData(data: tItemModel) {
        return this.http.delete(this.baseurl + this.pathName + '/Formatted/' + data.shopID + '/' + data.itemID);
    }

    updateData(data: tItemModel) {
        //   data.lastModifyLoginName = "2";
        return this.http.put(this.baseurl + this.pathName + '/Formatted/' + data.shopID + '/' + data.itemID, data);
    }
}